import { callApi } from '@nfib/engage-framework';

export const LOCATION_ORIGIN = (() => {
  if (typeof window !== 'undefined' && window.location !== 'undefined') {
    const url =
      window.location.origin ||
      window.location.protocol +
        '//' +
        window.location.hostname +
        (window.location.port ? ':' + window.location.port : '');
    if (url.toString() !== 'null') {
      return url;
    }
  }
  return 'http://localhost';
})();

export default callApi(LOCATION_ORIGIN);



// WEBPACK FOOTER //
// ./src/common/call-api.js